import { StyleSheet } from '@react-pdf/renderer';

export default StyleSheet.create({
  // Estilos para la página principal del documento
  page: {
    paddingTop: '4cm', // Espacio para el header (3.5cm + 0.5cm de margen)
    paddingBottom: '4cm', // Espacio para el footer (3.5cm + 0.5cm de margen)
    paddingHorizontal: '1.5cm',
    backgroundColor: '#ffffff',
    minHeight: '100vh',
  },

  // Estilos para la portada (sin padding)
  portraitPage: {
    backgroundColor: '#ffffff',
    height: '100vh',
  },

  // Contenedor principal del cuerpo
  bodyPresupuesto: {
    flex: 1,
    paddingTop: '1cm',
  },

  // Imágenes
  img: {
    maxWidth: '150px',
    margin: '10px',
  },

  // Contenedor horizontal
  horizontalContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
    maxHeight: '200px',
  },

  // Items del presupuesto
  item: {
    marginBottom: '1cm',
    padding: '0.5cm 0',
    borderBottom: '1px solid #f0f0f0',
  },

  // Párrafos
  p: {
    textIndent: '40px',
    lineHeight: 1.4,
    fontSize: '11px',
    color: '#34495e',
  },

  // Contenedor de despedida
  bye: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: '2cm',
  },

  // Texto fuerte/bold
  textStrong: {
    fontSize: '12px',
    fontFamily: 'Helvetica-Bold',
    color: '#2c3e50',
  },

  // Texto secundario
  subText: {
    fontSize: '10px',
    color: '#7f8c8d',
    fontStyle: 'italic',
  },

  // Texto del logo
  textLogo: {
    fontSize: '12px',
    color: '#548235',
    fontFamily: 'Helvetica-Bold',
  },
});
